import Loadable from "react-loadable";

import { Loading } from "../../common/navigation";

const Connections = Loadable({
  loader: () => import("./components/connections"),
  loading: Loading
});

const ConnectionDetais = Loadable({
  loader: () => import("./components/connections_details"),
  loading: Loading
})




export const routes = [
  {
    path: '/connections',
    exact: true,
    name: 'connections',
    component: Connections,
    // "permission": {
    //   "contactype": [
    //     "affiliate",
    //     "student",
    //     "faculty"
    //   ],
    //   "group": [

    //   ]
    // },
  },
  {
    path: '/connections/connection_details/:id',
    exact: true,
    name: 'connection details',
    component: ConnectionDetais,
    // "permission": {
    //   "contactype": [
    //     "affiliate",
    //     "student",
    //     "faculty"
    //   ],
    //   "group": [

    //   ]
    // },
  }
];

// export * from "./connectionsActions";
// export * from "./connectionsReducer";